import React, { useEffect, useState } from "react";
import {
  Row,
  Col,
  Typography,
  Button,
  Divider,
  Grid,
  Modal,
  Card,
  message,
} from "antd";
import { useLocation, useNavigate } from "react-router-dom";
import CartLeadRow from "./CartLeadRow";
import axiosNew from "../../store/api/axiosNew";
import { ShoppingCartOutlined } from "@mui/icons-material";
import ArrowBackOutlinedIcon from "@mui/icons-material/ArrowBackOutlined"; // Outlined MUI Icon
import { useSelector } from "react-redux";

const { Title, Text } = Typography;
const { useBreakpoint } = Grid;

// --- Load Razorpay Script ---
const loadRazorpay = () =>
  new Promise((resolve) => {
    const script = document.createElement("script");
    script.src = "https://checkout.razorpay.com/v1/checkout.js";
    script.onload = () => resolve(true);
    script.onerror = () => resolve(false);
    document.body.appendChild(script);
  });

function MyCart() {
  const navigate = useNavigate();
  const location = useLocation();
  const screens = useBreakpoint();
  const isMobile = !screens.md;

  const [cart, setCart] = useState(null);
  const [cartWithLeads, setCartWithLeads] = useState([]);
  const [loading, setLoading] = useState(true);
  const userId =
    useSelector((state) => state.login?.response?.data?.userData?.userId) ||
    localStorage.getItem("userId");

  // const userFromRedux = useSelector((state) => state.login.response?.userData);
  // const userFromStorage = JSON.parse(localStorage.getItem("loginResponse")); // fallback
  // const user = userFromRedux || userFromStorage;
  // const userId = user?.userId;

  console.log("uid", userId);
  // --- Fetch cart ---

  const fetchCart = async () => {
    try {
      const token = localStorage.getItem("accessToken");
      const res = await axiosNew.get(`/cart/${userId}`, {
        headers: { Authorization: `Bearer ${token}` },
      });

      if (res.data.success) {
        setCart(res.data.cart);

        // Map leads to frontend structure
        const mappedLeads = res.data.cart.items.map((item) => ({
          _id: item._id,
          lead: item.leadDetails || { _id: item.leadId },
          price: item.currentRate || item.price,
          quantity: item.quantity,
          addedAt: item.addedAt,
        }));

        setCartWithLeads(mappedLeads);
      }
    } catch (err) {
      console.error("Failed to load cart", err);
      message.error("Could not load your cart.");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (!userId) return; // wait until userId is available
    fetchCart();
  }, [userId]);

  // --- Delete lead ---
  const handleDelete = (leadId) => {
    Modal.confirm({
      title: "Remove lead from cart?",
      content: "Are you sure you want to remove this lead from your cart?",
      centered: true,
      okText: "Yes, remove",
      cancelText: "Cancel",
      okType: "danger",

      onOk: async () => {
        try {
          const token = localStorage.getItem("accessToken");
          const cartUserId = localStorage.getItem("cartUserId");
          const userId = localStorage.getItem("userId");

          await axiosNew.delete(
            `https://apilead.blaccdot.com/api/cart/${userId}/${leadId}`,
            { headers: { Authorization: `Bearer ${token}` } },
          );

          // setCartWithLeads((prev) =>
          //   prev.filter((item) => item.lead._id !== leadId),
          // );
          fetchCart();
        } catch (error) {
          console.error("Failed to remove item", error);
          message.error("Failed to remove lead.");
        }
      },
    });
  };

  // --- Checkout ---
  const handleCheckout = async () => {
    const isLoaded = await loadRazorpay();
    if (!isLoaded) return message.error("Razorpay failed to load");

    try {
      const token = localStorage.getItem("accessToken");
      const res = await axiosNew.post(
        "https://apilead.blaccdot.com/api/payment/create-order",
        {},
        { headers: { Authorization: `Bearer ${token}` } },
      );

      const { razorpayOrder, razorpayKey } = res.data;

      const options = {
        key: razorpayKey || "YOUR_RAZORPAY_KEY",
        amount: razorpayOrder.amount,
        currency: "INR",
        name: "Blaccdot",
        description: "Lead Buying System Engine",
        order_id: razorpayOrder.id,
        theme: { color: "#000000" },
        handler: async (response) => {
          try {
            const verifyRes = await axiosNew.post(
              "https://apilead.blaccdot.com/api/payment/verify",
              {
                orderId: response.razorpay_order_id,
                paymentId: response.razorpay_payment_id,
                signature: response.razorpay_signature,
                rawLogs: response,
              },
              { headers: { Authorization: `Bearer ${token}` } },
            );

            if (verifyRes.data.success) {
              console.log("verifyRes", verifyRes);
              const transactionId = verifyRes.data.transaction._id;

              message.success("Order Placed Successfully!");
              navigate(`/admin/transactions/${transactionId}/invoice`);
            }
          } catch (error) {
            message.error("Verification failed. Please contact support.");
          }
        },
        prefill: {
          name: localStorage.getItem("userName") || "",
          email: localStorage.getItem("userEmail") || "",
        },
      };

      const rzp = new window.Razorpay(options);
      rzp.open();
    } catch (error) {
      message.error("Failed to initiate checkout.");
    }
  };

  // --- Render loading / empty state ---
  if (loading) return <div>Loading cart...</div>;

  if (!cartWithLeads || cartWithLeads.length === 0) {
    return (
      <div
        style={{
          minHeight: "60vh",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <Card
          style={{
            maxWidth: 420,
            width: "100%",
            textAlign: "center",
            borderRadius: 12,
            border: "1px dashed #d9d9d9",
          }}
        >
          <ShoppingCartOutlined style={{ fontSize: 48, color: "#1677ff" }} />
          <Title level={4} style={{ marginTop: 12 }}>
            Your cart is empty
          </Title>
          <Text type="secondary">
            Looks like you haven’t added any leads yet.
          </Text>
          <Divider />
          <Button
            type="primary"
            size="large"
            block
            onClick={() => navigate("/user-dashboard")}
          >
            Browse Leads
          </Button>
        </Card>
      </div>
    );
  }

  const total = cart?.totalPrice || 0;
  const sgst = cart?.sgst || 0;
  const cgst = cart?.cgst || 0;
  const grandTotal = cart?.grandTotal || 0;

  return (
    <div>
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          marginBottom: 20,
        }}
      >
        <Title
          level={3}
          style={{ margin: 0, fontWeight: 600, color: "#1f1f1f" }}
        >
          My Cart
        </Title>
        <Button
          className="custom-back-btn"
          icon={<ArrowBackOutlinedIcon />}
          onClick={() => navigate(-1)}
          aria-label="Go back"
          title="Go back"
        />
      </div>
      <Row gutter={[16, 16]}>
        <Col span={24} md={12}>
          <div
            style={{
              border: "1px solid #d3e6ff",
              borderRadius: 8,
              padding: 16,
              marginBottom: 16,
            }}
          >
            <Text strong>My Cart ({cartWithLeads.length})</Text>
            <Divider />
            {cartWithLeads.map((item, i) => (
              <div key={item._id}>
                <CartLeadRow
                  lead={{
                    id: item.lead._id,
                    name: item.lead.name,
                    place: item.lead.location,
                    subcategory: item.lead.subcategory,
                    price: item.price,
                    rating: `${item.lead.timesBought || 0}/${
                      item.lead.leadAvailableCount || 0
                    }`,
                    quantity: item.quantity,
                    addedAt: item.addedAt,
                  }}
                  onDelete={handleDelete}
                />
                {i !== cartWithLeads.length - 1 && <Divider />}
              </div>
            ))}
          </div>
        </Col>

        <Col span={24} md={12}>
          <div
            style={{
              border: "1px solid orange",
              borderRadius: 8,
              padding: 16,
              color: "orange",
              fontWeight: 600,
              marginBottom: 16,
            }}
          >
            Important Notice
            <div>Lead prices may change during checkout</div>
          </div>

          <div
            style={{
              border: "1px solid #d3e6ff",
              borderRadius: 8,
              padding: 16,
            }}
          >
            <Text strong>Order Summary</Text>
            <Divider />
            <Row justify="space-between">
              <Text>No of Leads</Text>
              <Text>{cartWithLeads.length}</Text>
            </Row>
            <Row justify="space-between">
              <Text>Date</Text>
              <Text>
                {cart?.createdAt
                  ? new Date(cart.createdAt).toLocaleDateString("en-GB")
                  : "-"}
              </Text>
            </Row>
            <Divider />
            <Row justify="space-between">
              <Text>Subtotal</Text>
              <Text>₹{total?.toFixed(2)}</Text>
            </Row>

            <Row justify="space-between">
              <Text>SGST</Text>
              <Text>₹{sgst?.toFixed(2)}</Text>
            </Row>

            <Row justify="space-between">
              <Text>CGST</Text>
              <Text>₹{cgst?.toFixed(2)}</Text>
            </Row>

            <Divider />

            <Row justify="space-between">
              <Text strong style={{ fontSize: 16 }}>
                Grand Total
              </Text>
              <Text strong style={{ fontSize: 16 }}>
                ₹{grandTotal?.toFixed(2)}
              </Text>
            </Row>

            <Button
              type="primary"
              block
              style={{
                marginTop: 16,
                backgroundColor: "#000",
                borderColor: "#000",
              }}
              onClick={handleCheckout}
            >
              Checkout
            </Button>
          </div>
        </Col>
      </Row>
    </div>
  );
}

export default MyCart;
